import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import HomePage from "@/pages/HomePage";
import PartnerPage from "@/pages/PartnerPage";
import SupportPage from "@/pages/SupportPage";
import AdminPage from "@/pages/AdminPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/partner" element={<PartnerPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/help" element={<SupportPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
